import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/propietarios",
        label: "Propietarios",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarPropietario(){
    return (
        <Page title="Edición de Propietario" description="Modificación de datos de propietario." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarPropietario;